import React from 'react';
import {Form, Tooltip, Popconfirm, InputNumber, message, Button, Input, Select, DatePicker, Row} from 'antd';
import ModalDom from '../../../../../components/Modal';
import DetailTitle from '../../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../../components/Custom';
import { post, postFrom, config } from '../../../../../axios';
import { dicPayChannel, customerType } from '../../../../../axios/dictionaries';
import { moneyAddComma, handleDeepCopy } from '../../../../../utils';
import Add from './Add';
import moment from 'moment';
import FileUpload from "../../../../../components/FileUpload";

const Option = Select.Option;

class Page extends React.Component {
    constructor() {
        super();
        this.findCustomer = { //精确查找个人的参数
            customerType: 2,
            keyword: ''
        };
        this.initState = {
            loading: false,
            showAddModal: false,
            data: {},
            turnAway: [],
        };
        this.state = {
            ...handleDeepCopy(this.initState)
        };
    }

    handleCancel = () => { //关闭页面
        this.findCustomer = {
            customerType: 2,
            keyword: ''
        };
        this.setState({ ...handleDeepCopy(this.initState) }, () => {
            this.props.handleCancel();
        });
    }

    loadPackageClearAttachIds =() =>{
        if( this.fileUploadRef){
            this.fileUploadRef.setFileToState([]);
        }

    }

    loadPackage = (id) => {


        this.setState({ loading: true });
        this.billId = id;
        postFrom({ url: config.API_bill_findBillEndById, data: { billId: this.billId } }).then(res => {
            this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });
    }

    handleShowAdd = () => {
        if (this.state.data.id) {
            this.setState({ showAddModal: true });
            this.addRef.loadPackage(this.state.data.id);
        } else {
            message.error('未查询到租客！');
        }
    }

    handleSearch = () => {
        this.setState({ loading: true });
        postFrom({ url: config.API_customer_findOneByPhoneOrCredentialNumber, data: this.findCustomer }).then(res => {
            if (res) {
                this.setState({ loading: false, data: res, turnAway: [] });
            } else {
                this.setState({ loading: false, data: {}, turnAway: [] });
                message.error('该租客不存在');
            }
        }).catch(err => {
            message.error(err.message || '查询失败');
            this.setState({ loading: false });
        });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                let { turnAway } = this.state;
                if (turnAway.length) {
                    this.setState({ loading: true });
                    values.customerId = this.state.data.id;
                    values.payDate = values.payDate.format('YYYY-MM-DD');
                    values.otherBillVoList = turnAway.map(item => {
                        return {
                            billId: item.id,
                            money: values[`writeOffMoney-${item.id}`]
                        }
                    });

                    for (let key in values) {
                        if (key.startsWith('writeOffMoney-')) {
                            delete values[key]
                        }
                    }
                    console.log(this.fileUploadRef.parseAttachToIds());
                    values.attachIds = this.fileUploadRef.parseAttachToIds()

                    post({ url: config.API_traderecordoffline_add, data: values }).then(res => {
                        message.success('登记成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '登记失败');
                        this.setState({ loading: false });
                    });
                } else {
                    message.error('请选择核销账单');
                }
            }
        })
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    render() {
        let { visible, form: { getFieldDecorator } } = this.props;
        let {
            loading,
            showAddModal,
            data,
            turnAway,
        } = this.state;

        return <ModalDom
            title="转账登记"
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <Form>
                <div className="custom">
                    <CustomRow title="转账">
                        <CustomCol label="转账渠道">
                            {getFieldDecorator('payChannel', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: 1
                            })(
                                <Select
                                    showSearch
                                    placeholder="请选择"
                                    optionFilterProp={'children'}
                                >
                                    {dicPayChannel.map((item, index) => <Option value={item.value} key={item.value} title={item.title}>{item.title}</Option>)}
                                </Select>
                            )}
                        </CustomCol>
                        <CustomCol label="转账日期">
                            {getFieldDecorator('payDate', {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                initialValue: moment()
                            })(
                                <DatePicker />
                            )}
                        </CustomCol>
                    </CustomRow>
                    <CustomRow title={true} divider>
                        <CustomCol label="转账金额" subfix={<div>元</div>} subfixRight={30}>
                            {getFieldDecorator('amount', {
                                initialValue: 0,
                                rules: [{
                                    required: true, message: '请输入',
                                }]
                            })(
                                <InputNumber
                                    placeholder={'请输入'}
                                    min={0}
                                    formatter={value => value !== '' ? value : 0}
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="入账渠道">
                            {getFieldDecorator('searialNumber', {
                                rules: [{
                                    required: true, message: '请输入进账渠道',
                                }]
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                        <CustomCol label="交易参考号">
                            {getFieldDecorator('referenceNumber', {
                                rules: [{
                                    required: true, message: '请输入交易参考号',
                                }]
                            })(
                                <Input
                                    placeholder={'请输入'}
                                    autoComplete={'off'}
                                />
                            )}
                        </CustomCol>
                    </CustomRow>


                    <CustomRow title="租客" divider>
                        <CustomCol label="租客类型">
                            <Select
                                showSearch
                                placeholder="请选择"
                                optionFilterProp={'children'}
                                defaultValue={2}
                                onChange={(value) => {
                                    this.findCustomer.customerType = value;
                                }}
                            >
                                {customerType.map((item, index) => <Option value={item.value} key={item.value} title={item.title}>{item.title}</Option>)}
                            </Select>
                        </CustomCol>
                        <CustomCol
                            labelStyle={{ flex: '0 0 200px', width: '200px', padding: 0 }}
                            required={"none"}
                            label={
                                <Input
                                    placeholder={'精确搜索手机号码、证件号码'}
                                    autoComplete={'off'}
                                    onChange={(e) => {
                                        this.findCustomer.keyword = e.target.value;
                                    }}
                                />
                            }
                            colStyle={{ width: '0' }}
                        >
                        </CustomCol>
                        <Button
                            onClick={this.handleSearch}
                            style={{ width: '100px', height: '36px', borderRadius: 0, background: '#f0f2f5' }}
                        >查询</Button>
                    </CustomRow>
                    <CustomRow title={true} divider>
                        <CustomCol label="姓名" required={false}>
                            <Input
                                value={data.name}
                                disabled
                            />
                        </CustomCol>
                        <CustomCol label="证件号码" required={false}>
                            <Input
                                value={data.credentialNumber}
                                disabled
                            />
                        </CustomCol>
                        <CustomCol label="手机号" required={false}>
                            <Input
                                value={data.phone}
                                disabled
                            />
                        </CustomCol>
                    </CustomRow>
                    <div className="hr"></div>
                </div>
                <DetailTitle title="核销账单" />
                <div className="custom">
                    <div className="tableBox">
                        <div className="tableTitle">
                            <div style={{ flex: 1 }}>应收日期</div>
                            <div style={{ flex: 1 }}>房源</div>
                            <div style={{ flex: 1 }}>账单名称</div>
                            <div style={{ flex: 1 }}>账单周期</div>
                            <div style={{ flex: 1 }}>应收金额（元）</div>
                            <div style={{ flex: 1 }}>待收金额（元）</div>
                            <div style={{ flex: 1 }} className="xinxin xinxinColor">核销金额（元）</div>
                            <div style={{ flex: '0 0 80px' }}>操作</div>
                        </div>
                        <div className="tableBody">
                            {
                                turnAway.length
                                    ? turnAway.map((item, index) => {
                                        return <div className="tableBodyRow" style={{ textAlign: 'center' }} key={index}>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ padding: '5px', lineHeight: '16px' }}>
                                                    <div style={{ color: "red" }}>{item.overdueDays ? `逾期${item.overdueDays}天` : null}</div>
                                                    <div>{item.mustPayDate ? moment(item.mustPayDate).format('YYYY-MM-DD') : ""}</div>
                                                </div>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ padding: '5px', lineHeight: '18px' }}>
                                                    <div>{item.roomNo}</div>
                                                    <div>{item.buildingName}</div>
                                                </div>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ padding: '5px', lineHeight: '18px' }}>
                                                    {item.feeName}
                                                </div>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <div style={{ padding: '5px', lineHeight: '18px' }}>
                                                    <div>{item.billBeginDate ? moment(item.billBeginDate).format('YYYY-MM-DD') : null}</div>
                                                    <div>{item.billEndDate ? moment(item.billEndDate).format('YYYY-MM-DD') : null}</div>
                                                </div>
                                            </div>
                                            <div style={{ flex: 1, justifyContent: 'flex-end' }}>
                                                <div style={{ padding: '0 25px', lineHeight: '18px', textAlign: 'right' }}>
                                                    <div>{moneyAddComma(item.billMoney)}</div>
                                                </div>
                                            </div>
                                            <div style={{ flex: 1, justifyContent: 'flex-end' }}>
                                                <div style={{ padding: '0 25px', lineHeight: '18px', color: 'red' }}>
                                                    <div>{moneyAddComma(item.billMoney - item.receivedMoney)}</div>
                                                </div>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                {getFieldDecorator(`writeOffMoney-${item.id}`, {
                                                    initialValue: item.writeOffMoney || 0
                                                })(
                                                    <InputNumber
                                                        style={{ paddingRight: '25px' }}
                                                        className="money-right"
                                                        placeholder={'请输入'}
                                                        max={item.billMoney - item.receivedMoney}
                                                        min={0}
                                                        formatter={value => value !== '' ? value : 0}
                                                        onChange={(value) => {
                                                            turnAway[index].writeOffMoney = value;
                                                            this.setState({ turnAway });
                                                        }}
                                                    />
                                                )}
                                            </div>
                                            <div style={{ flex: '0 0 80px' }}>
                                                <Popconfirm
                                                    placement="topRight"
                                                    title={'此删除操作不可恢复，确定删除吗？'}
                                                    onConfirm={() => {
                                                        let { turnAway } = this.state;
                                                        turnAway.splice(index, 1);
                                                        this.setState({ turnAway });
                                                    }}
                                                    okText="删除"
                                                    cancelText="取消"
                                                >
                                                    <span className="showClickDetail">删除</span>
                                                </Popconfirm>
                                            </div>
                                        </div>
                                    })
                                    : <div className="tableBodyRow" style={{ height: '34px', lineHeight: '34px', justifyContent: 'center', color: '#888' }}>暂无数据！</div>
                            }
                            <div className="tableBodyRow" style={{ justifyContent: 'space-between', alignItems: 'center', height: '34px', padding: '0 35px 0 20px' }}>
                                <span>核销金额合计：<span style={{ color: 'red' }}>{moneyAddComma(turnAway.reduce((total, item) => total + item.writeOffMoney || 0, 0))}</span>元</span>
                                <Tooltip placement="bottomLeft" title={"添加合同账单"}>
                                    <Button onClick={this.handleShowAdd} style={{ width: '24px', height: '24px', lineHeight: '16px', fontSize: '14px' }} shape="circle" icon="plus" />
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <Add
                    onRef={ref => this.addRef = ref}
                    visible={showAddModal}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    setList={(value) => { value = value.map(item => { item.writeOffMoney = item.billMoney - item.receivedMoney; return item }); this.setState({ turnAway: value }) }}
                />
                <DetailTitle title="转账附件" />
                <FileUpload hideLabel ref={(ref) => this.fileUploadRef = ref} tableName="tradeRecordOffline"  fileTypeList={[17]} isValueStyle={true}/>
            </Form>
        </ModalDom>
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Payment/components/Transfer/CheckIn/index.js